export enum UserTypes {
    Unauthenticated = "Unauthenticated",
    SuperAdmin = "SuperAdmin",
    GlobalAdmin = "GlobalAdmin",
    Member = "Member",
    Provider = "Provider",
}
